//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { mergeQueryParamsWithDeepLink } from '~/utils/helpers';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { getError } from "~/utils/vuelidate";
import IconCross from '~/assets/img/icons/cross.svg?inline';

export default {
  name: 'UiCalculatorProducts',
  mixins: [validationMixin],
  components: {
    IconCross,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    carNumber: String,
    popupAppTitle: String,
    popupAppQrDescription: String,
    popupAppFormDescription: String,
    smsText: String,
  },
  data() {
    return {
      showPopup: false,
      activeItem: null,
      phoneVal: '',
      pending: false,
      success: false,
      timeoutID: undefined,
      queryParams: null,
    }
  },
  validations: {
    phoneVal: {
      required,
      isValid(value) {
        return value.replace(/\D/g, "").length === 12;
      },
    },
  },
  computed: {
    ...mapState('smart', ['url']),
    errors() {
      return {
        phoneVal: getError(this.$v.phoneVal, {
          required: this.$t('field-required'),
          isValid: this.$t('invalid-value'),
        }),
      };
    },
    getSmartLink() {
      if (typeof this.url === 'string') {
        return typeof this.queryParams === 'object' && this.queryParams !== null
          ? mergeQueryParamsWithDeepLink(this.url, this.queryParams)
          : this.url;
      }

      return '';
    },
  },
  methods: {
    async handleShowPopup(item) {
      this.activeItem = item;
      this.getQueryParams(item?.id);
      this.showPopup = true;
    },
    handleClosePopup() {
      this.showPopup = false;
    },
    getQueryParams(packId) {
      const carNumber = this.carNumber;
      const { ref, partner } = this.$route.query;

      this.queryParams = { carNumber, packId, ref, partner };
    },
    async handleSubmit() {
      this.hideSuccess();
      this.$v.phoneVal.$touch();
      if (this.$v.phoneVal.$invalid) return;

      this.pending = true;

      try {
        const data = await this.$axios.$post('https://core.easypeasy.com.ua/api/public/client/send_sms', {
          phone: this.phoneVal.replace(/\D/g, "").slice(2),
          text: this.getSmsText()
        });
        this.showSuccess();
        this.phoneVal = '';
        this.$v.phoneVal.$reset();
      } catch(err) {
        console.error(err);
      } finally {
        this.pending = false;
      }
    },
    showSuccess() {
      this.success = true;
      this.timeoutID = setTimeout(() => {
        this.success = false;
      }, 5000);
    },
    clearTimeoutSuccess() {
      if (this.timeoutID) {
        clearTimeout(this.timeoutID);
      }
    },
    hideSuccess() {
      this.clearTimeoutSuccess();
      this.success = false;
    },
    handleInputPhone() {
      this.$v.phoneVal.$reset();
      if (!this.pending) {
        this.hideSuccess();
      }
    },
    getSmsText() {
      const str = this.smsText || '';
      const regex = /\$\{link\}/gm;

      return str.trim() ? str.replace(regex, this.getSmartLink) : this.getSmartLink;
    },
  },
  beforeDestroy() {
    this.clearTimeoutSuccess();
  },
}
